export default {
  cancelReasonLabel: 'Motivo de la cancelación (Opcional)',
};